export default __webpack_public_path__ + "static/media/whatsapp.db591509.svg";